import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    constructor() {}
    private readonly appOrigin$ = new BehaviorSubject<'mykempower' | 'chargeye'>(this.determineAppOrigin());

    private determineAppOrigin(): 'mykempower' | 'chargeye' {
        const url = window.location.href;
        const includeLocalhost = false; // for development
        const mykempowerPattern = new RegExp(
            `^https?:\\/\\/${includeLocalhost ? 'localhost|' : ''}(?:dev\\.|test\\.)?mykempower\\.com`
        );
        return mykempowerPattern.test(url) ? 'mykempower' : 'chargeye';
    }
    toggle() {
        this.appOrigin$.next(this.appOrigin$.value === 'mykempower' ? 'chargeye' : 'mykempower');
    }

    getAppOrigin$(): Observable<'mykempower' | 'chargeye'> {
        return this.appOrigin$.asObservable();
    }
}
